import { mimicTypeIdSchema } from '@eigtech/typeid';
import { z } from 'zod';
export const quickbooksIdPrefix = 'quickbooks';
export const QuickbooksIdSchema = mimicTypeIdSchema(quickbooksIdPrefix);
export const JobExternalIdTypeEnumSchema = z.enum([quickbooksIdPrefix]);
export const JobExternalIdSchema = QuickbooksIdSchema;
